document.addEventListener("DOMContentLoaded", function () {
	const popup = document.getElementById("popup");
	const closeBtn = document.querySelector(".popup__close");
	const openBtn = document.createElement("span");

	if (!popup) {
		return;
	}

	openBtn.classList.add("popup__open");

	document.querySelector(".popup__content").appendChild(openBtn);

	// Function to update the popup state in localStorage
	const updatePopupState = (state) => {
		localStorage.setItem("popupState", state);
	};

	// Retrieve the popup state from localStorage
	const savedState = localStorage.getItem("popupState");
	if (savedState === "descaled") {
		popup.classList.add("descaled");
	}

	closeBtn.onclick = function () {
		popup.classList.add("descaled");
		updatePopupState("descaled");
	};

	openBtn.onclick = function () {
		popup.classList.remove("descaled");
		updatePopupState("expanded");
	};
});
